/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ProjectItemInterface } from 'utils/scrolling';
import { getSvgIcon } from '../../../resources';
import AppStyle from '../../../scss/main/App.module.scss';
import ProjectStaggeredItems from 'components/ProjectStaggeredItems';

const MAD: React.FC<{}> = () => {

  const image1: any = useRef<HTMLInputElement>(null);
  const image2: any = useRef<HTMLInputElement>(null);
  const image3: any = useRef<HTMLInputElement>(null);
  const image4: any = useRef<HTMLInputElement>(null);

  const items: ProjectItemInterface[] = [
    {
      src: "744fae027e362cf5dd95ca0a7a0ac06d1d3517c99bb594f0bc62b0141bc31691.webp",
      title: "ScoRex - Social & eCommerce Mobile Apps.",
      ref: image1
    },
    {
      src: "32850baf4bfe5a93b733f4a057caf160609ba2594b3d827ad2bffe23d4fb6fce.webp",
      title: "Sland  - FinTech, Securities & Futures information demo mobile apps.",
      ref: image2
    },
    {
      src: "42e088ae38951ff131bdfbe41278be400ba0ed2907a4fdea1d0aee8b93dd362b.webp",
      title: "Lons - FinTech & Forex information mobile apps.",
      ref: image3
    },
    {
      src: "a0bc872b2d91e0c29ba06f285ee174897105b745b19071f2fb1bce1f7ab77e51.webp",
      title: "Scrummy - Social, Forum and sharing mobile apps.",
      ref: image4
    }
  ]

  return (
    <div className={AppStyle["skill-mad"]}>
      <div>
        <div>
          <div>
            Cross-platform Technology
          </div>
        </div>
        <div>
          <div>
            <div>Cross-platform development is an emerging development technology, which is characterized by the ability to develop cross-platform mobile applications at the same time, so any project that targets rapid development can consider using this technology. At the same time, this technology will be conducive to maintenance and subsequent development.</div>
            <div>Currently, I mainly use React Native and Flutter as technologies for developing cross-platform mobile applications. React Native is based on React technology, so that the development languages which are currently used in JavaScript engines in browsers, such as JavaScript and TypeScript can be used as project development language, and also can maintain commonality with web projects. Flutter was developed based on the new rendering native engine, so the standard performance of Flutter would be faster and lighter than React Native.</div>
          </div>
        </div>
      </div>
      <ProjectStaggeredItems items={items} elasticity={0.5} />
      <div>
        <div>
          <div>
            Native mobile Technology
          </div>
        </div>
        <div>
          <div>
            <div>Native mobile application development method is still the mainstream development method. Since this method is a native development method, the development of any project type will not be restricted. Native development is also the development method that can maximize the performance and flexibility of the device.</div>
            <div>Currently, I mainly use Swift to develop iOS applications, and using Kotlin to develop Android applications. But no matter which programming language is used to develop applications, ensuring the balance of application quality and performance is also one of my top work priorities. At the same time, I can also ensure the unity between the two platform applications, so that the user experience of the two platforms would not be much different.</div>
          </div>
        </div>
      </div>
      <div>
        <div>
          Main<br />Technology
        </div>
        <div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'cross' })}` }} />
            <div>
              Cross-platform Development
            </div>
            <div>
              As the name suggests, is for cross-platform development. Currently, I will use React Native and Flutter to develop cross-platform mobile applications, and I will focus on the iOS and Android platforms.
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'native' })}` }} />
            <div>
              Native Mobile Development
            </div>
            <div>
              This is the most traditional development model. Native development tools, such as Xcode and Android Studio, can result in the most compatible development program for system-layer APIs. The development work in this way takes the longest time, but the result is the most ideal.
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'ai' })}` }} />
            <div>
              Artificial Intelligence
            </div>
            <div>
              At present, the role of AI is becoming more and more extensive. In iOS, Apple has also developed a lot of practical models that can be used for image recognition, voice recognition and other aspects. I can use Core ML or Tensorflow Lite to implement some functions according to different needs.
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'ux' })}` }} />
            <div>
              User Experience Design
            </div>
            <div>
              The actual user experience is equivalent to the value of a mobile application. Therefore, I will design and develop from the perspective of users to achieve human-centered standards.
            </div>
          </div>
        </div>
      </div>
      <div>
        <div>
          List of<br />Development<br />Technologies
        </div>
        <div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'rn' })}` }} />
            <div>
              React Native
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'flutter' })}` }} />
            <div>
              Flutter
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'ios' })}` }} />
            <div>
              iOS
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'android' })}` }} />
            <div>
              Android
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'swift' })}` }} />
            <div>
              SwiftUI
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'coreml' })}` }} />
            <div>
              Core ML
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'arkit' })}` }} />
            <div>
              ARKit
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'tf' })}` }} />
            <div>
              Tensorflow Lite
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'arcore' })}` }} />
            <div>
              ARCore
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: `${getSvgIcon({ name: 'pwa' })}` }} />
            <div>
              PWA
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className={`${AppStyle["buttonLine"]}`}>
          <Link to='/skills'>
            Show Me Others
            <div className={AppStyle["button-border"]} />
          </Link>
        </div>
      </div>
    </div>
  )
}

export default MAD